// Gallery media for Yogarambh Wellness.
// Images were extracted from Suman's portfolio. Add/replace items freely.
// type: "image" | "video".  For video, set `src` to an embeddable URL.

export const gallery = [
  {
    type: "image",
    src: "/gallery/hero-waterfront.jpg",
    alt: "Suman practising a seated side bend by the Hong Kong waterfront",
  },
  {
    type: "image",
    src: "/gallery/side-bend.jpg",
    alt: "Standing side stretch outdoors",
  },
  {
    type: "image",
    src: "/gallery/side-plank.jpg",
    alt: "Side plank variation against a stone wall",
  },
  {
    type: "image",
    src: "/gallery/kids-meditation.jpg",
    alt: "Kids yoga meditation circle",
  },
  {
    type: "image",
    src: "/gallery/tadasana.jpg",
    alt: "Tadasana (mountain pose) demonstration",
  },
  {
    type: "image",
    src: "/gallery/namaskarasana.jpg",
    alt: "Namaskarasana (garland / squat pose)",
  },
  {
    type: "image",
    src: "/gallery/bow-pose.jpg",
    alt: "Dhanurasana (bow pose)",
  },
  {
    type: "image",
    src: "/gallery/om-mantra.jpg",
    alt: "Om Namah Shivaya mantra mandala",
  },
  {
    type: "image",
    src: "/gallery/nourish.jpg",
    alt: "Nourishing you to bloom — wellness illustration",
  },
  // Example video placeholder — replace src with a real embed URL when ready:
  // {
  //   type: "video",
  //   src: "https://www.youtube.com/embed/VIDEO_ID",
  //   alt: "Tadasana tutorial",
  // },
];

export default gallery;
